// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.1_@swc+helpers@0.5.17__webpack@5.102.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.1_@swc+helpers@0.5.17__webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M1vlR {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}
.UThTM {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.UThTM img {
  width: 140px;
  height: 146px;
  flex-shrink: 0;
  aspect-ratio: 70/73;
}
.UThTM span {
  color: #999;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}
.rGdsS {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pdfLoading": `M1vlR`,
	"pdfLoadingBox": `UThTM`,
	"pdfViewer": `rGdsS`
};
export default ___CSS_LOADER_EXPORT___;
